const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgThrescreens(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_3",
    "data-name": "Layer 3",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 524.13 255.38",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("circle", {
    cx: 87.69,
    cy: 157.69,
    r: 87.19,
    style: {
      fill: "none"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M112.93,197.37h-50.48c-.63,0-1.2-.38-1.45-.96l-18.17-43.14,30.41,12.41,14.44-31.68,14.44,31.68,30.41-12.41-13.29,31.55",
    style: {
      fill: "none",
      stroke: "#fbd800",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: 8
    }
  }), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.3
    }
  }, /*#__PURE__*/React.createElement("rect", {
    x: 349.25,
    y: 0.5,
    width: 174.38,
    height: 174.38,
    rx: 30,
    ry: 30,
    style: {
      fill: "none",
      stroke: "#fff",
      strokeMiterlimit: 10
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 0.5,
    y: 80.5,
    width: 174.38,
    height: 174.38,
    rx: 30,
    ry: 30,
    style: {
      fill: "none",
      stroke: "#fff",
      strokeMiterlimit: 10
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 87.69,
    cy: 167.69,
    r: 87.19,
    style: {
      fill: "none",
      stroke: "#fbd800",
      strokeMiterlimit: 10
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 174.88,
    y: 40.5,
    width: 174.38,
    height: 174.38,
    rx: 30,
    ry: 30,
    style: {
      fill: "none",
      stroke: "#fff",
      strokeMiterlimit: 10
    }
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("circle", {
    cx: 378.3,
    cy: 29.55,
    r: 29.05,
    style: {
      fill: "none",
      stroke: "#fff",
      strokeMiterlimit: 10
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 436.39,
    cy: 29.55,
    r: 29.05,
    style: {
      fill: "none",
      stroke: "#fff",
      strokeMiterlimit: 10
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 494.49,
    cy: 29.55,
    r: 29.05,
    style: {
      fill: "none",
      stroke: "#fff",
      strokeMiterlimit: 10
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 378.3,
    cy: 87.66,
    r: 29.05,
    style: {
      fill: "none",
      stroke: "#fff",
      strokeMiterlimit: 10
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 436.39,
    cy: 87.66,
    r: 29.05,
    style: {
      fill: "none",
      stroke: "#fff",
      strokeMiterlimit: 10
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 494.49,
    cy: 87.66,
    r: 29.05,
    style: {
      fill: "none",
      stroke: "#fff",
      strokeMiterlimit: 10
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 378.3,
    cy: 145.83,
    r: 29.05,
    style: {
      fill: "none",
      stroke: "#fff",
      strokeMiterlimit: 10
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 436.39,
    cy: 145.83,
    r: 29.05,
    style: {
      fill: "none",
      stroke: "#fff",
      strokeMiterlimit: 10
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 494.49,
    cy: 145.83,
    r: 29.05,
    style: {
      fill: "none",
      stroke: "#fff",
      strokeMiterlimit: 10
    }
  })), /*#__PURE__*/React.createElement("line", {
    x1: 349.25,
    y1: 29.55,
    x2: 523.46,
    y2: 29.55,
    style: {
      fill: "none",
      stroke: "#fff",
      strokeMiterlimit: 10
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 349.25,
    y1: 87.69,
    x2: 523.46,
    y2: 87.69,
    style: {
      fill: "none",
      stroke: "#fff",
      strokeMiterlimit: 10
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 349.25,
    y1: 146.47,
    x2: 523.46,
    y2: 146.47,
    style: {
      fill: "none",
      stroke: "#fff",
      strokeMiterlimit: 10
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 494.82,
    y1: 0.91,
    x2: 494.82,
    y2: 175.11,
    style: {
      fill: "none",
      stroke: "#fff",
      strokeMiterlimit: 10
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 436.68,
    y1: 0.91,
    x2: 436.68,
    y2: 175.11,
    style: {
      fill: "none",
      stroke: "#fff",
      strokeMiterlimit: 10
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 377.89,
    y1: 0.91,
    x2: 377.89,
    y2: 175.11,
    style: {
      fill: "none",
      stroke: "#fff",
      strokeMiterlimit: 10
    }
  })), /*#__PURE__*/React.createElement("circle", {
    cx: 494.49,
    cy: 29.55,
    r: 29.05,
    style: {
      fill: "none",
      stroke: "#fff",
      strokeMiterlimit: 10
    }
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("line", {
    x1: 494.82,
    y1: 0.52,
    x2: 494.82,
    y2: 58.72,
    style: {
      fill: "none",
      stroke: "#fff",
      strokeMiterlimit: 10
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 523.92,
    y1: 29.62,
    x2: 465.71,
    y2: 29.62,
    style: {
      fill: "none",
      stroke: "#fff",
      strokeMiterlimit: 10
    }
  })), /*#__PURE__*/React.createElement("path", {
    d: "M377.5,146.62s-1-45.21,58.59-58.59c59.59-13.38,59.29-59.29,59.29-59.29",
    style: {
      fill: "none",
      stroke: "#4fc642",
      strokeLinecap: "round",
      strokeMiterlimit: 10,
      strokeWidth: 8
    }
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 193.06,
    y: 58.25,
    width: 50.22,
    height: 8.61,
    rx: 4.3,
    ry: 4.3,
    style: {
      fill: "#c322ff"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 253.28,
    y: 169.9,
    width: 48.22,
    height: 8.61,
    rx: 4.3,
    ry: 4.3,
    style: {
      fill: "#c322ff"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 193.06,
    y: 114.08,
    width: 50.22,
    height: 8.61,
    rx: 4.3,
    ry: 4.3,
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 193.06,
    y: 169.9,
    width: 50.22,
    height: 8.61,
    rx: 4.3,
    ry: 4.3,
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 253.28,
    y: 132.69,
    width: 48.22,
    height: 8.61,
    rx: 4.3,
    ry: 4.3,
    style: {
      fill: "#009aff"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 253.28,
    y: 58.25,
    width: 24.78,
    height: 8.61,
    rx: 4.3,
    ry: 4.3,
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 253.28,
    y: 151.3,
    width: 24.78,
    height: 8.61,
    rx: 4.3,
    ry: 4.3,
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 288.06,
    y: 151.3,
    width: 43,
    height: 8.61,
    rx: 4.3,
    ry: 4.3,
    style: {
      fill: "#c322ff"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 311.5,
    y: 132.69,
    width: 19.57,
    height: 8.61,
    rx: 4.3,
    ry: 4.3,
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 288.06,
    y: 58.25,
    width: 25.78,
    height: 8.61,
    rx: 4.3,
    ry: 4.3,
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 303.28,
    y: 76.86,
    width: 27.78,
    height: 8.61,
    rx: 4.3,
    ry: 4.3,
    style: {
      fill: "#009aff"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 253.28,
    y: 76.86,
    width: 42,
    height: 8.61,
    rx: 4.3,
    ry: 4.3,
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 253.28,
    y: 95.47,
    width: 24.78,
    height: 8.61,
    rx: 4.3,
    ry: 4.3,
    transform: "translate(531.34 199.55) rotate(-180)",
    style: {
      fill: "#009aff"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 288.06,
    y: 95.47,
    width: 43,
    height: 8.61,
    rx: 4.3,
    ry: 4.3,
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 253.28,
    y: 114.08,
    width: 42,
    height: 8.61,
    rx: 4.3,
    ry: 4.3,
    style: {
      fill: "#c322ff"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 303.28,
    y: 188.51,
    width: 27.78,
    height: 8.61,
    rx: 4.3,
    ry: 4.3,
    style: {
      fill: "#009aff"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 253.28,
    y: 188.51,
    width: 42,
    height: 8.61,
    rx: 4.3,
    ry: 4.3,
    style: {
      fill: "#fff"
    }
  })), /*#__PURE__*/React.createElement("rect", {
    x: 174.88,
    y: 40.5,
    width: 174.38,
    height: 174.38,
    rx: 30,
    ry: 30,
    style: {
      fill: "none",
      stroke: "#fff",
      strokeMiterlimit: 10
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 87.69,
    cy: 167.69,
    r: 87.19,
    style: {
      fill: "none",
      stroke: "#fff",
      strokeMiterlimit: 10
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 174.9,
    cy: 147.69,
    r: 8,
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 349.25,
    cy: 107.69,
    r: 8,
    style: {
      fill: "#fff"
    }
  }));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgThrescreens);
export default __webpack_public_path__ + "static/media/threscreens.2dae19f7ca206cd351e4bce5f96b840e.svg";
export { ForwardRef as ReactComponent };